'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Fragment, useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import Url from 'urlinator/Url';
import { cancelMeeting as cancelMeetingAction, fetchEventDetails as fetchEventDetailsAction } from '../../redux/actions/BookActions';
import { track } from 'MeetingsLib/tracking/UsageTracker';
import { getMeetingsCancelStatus } from '../../selectors/RequestStatusSelectors';
import ProfileHeader from '../header/ProfileHeader';
import { STARTED, SUCCEEDED, FAILED } from 'MeetingsBase/constants/RequestStatusTypes';
import UIAlert from 'UIComponents/alert/UIAlert';
import { getMeetingSourceFromLocation } from 'MeetingsLib/utils/utils';
var CancelConfirmContainer = styled.div.withConfig({
  displayName: "CancelContainer__CancelConfirmContainer",
  componentId: "sc-37e0zg-0"
})(["max-width:600px;margin:0 auto;padding-top:48px;"]);

function SuccessState(_ref) {
  var profile = _ref.profile;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ProfileHeader, {
      profile: profile,
      cancelling: true,
      booked: false
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cancel.success.description"
    })]
  });
}

export default function CancelContainer(_ref2) {
  var profile = _ref2.profile;
  var dispatch = useDispatch();
  useEffect(function () {
    track('meetingEventInteraction', {
      action: 'viewed cancel',
      source: getMeetingSourceFromLocation()
    });
  }, []);
  var cancelRequestStatus = useSelector(function (state) {
    return getMeetingsCancelStatus(state);
  });
  var slug = useSelector(function (state) {
    return state.userSlug;
  });
  var meetingChangeId = useMemo(function () {
    var url = new Url(window.location);
    return url.paramValues('meetingChangeId');
  }, []);
  var eventDetails = useSelector(function (state) {
    return state.eventDetails;
  });
  useEffect(function () {
    dispatch(fetchEventDetailsAction(slug, meetingChangeId));
  }, [slug, meetingChangeId, dispatch]);
  var cancelMeeting = useCallback(function () {
    dispatch(cancelMeetingAction(slug, meetingChangeId));
  }, [dispatch, slug, meetingChangeId]);

  var cancelForm = /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ProfileHeader, {
      profile: profile,
      booked: false,
      cancelling: true
    }), eventDetails && /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "cancel.confirm.description",
        options: {
          eventName: eventDetails.eventName,
          meetingDateTime: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: eventDetails.startTime,
            format: "LLLL"
          })
        }
      })
    }), /*#__PURE__*/_jsx(UILoadingButton, {
      use: "primary",
      loading: cancelRequestStatus === STARTED,
      failed: cancelRequestStatus === FAILED,
      onClick: cancelMeeting,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cancel.confirm.cancel"
      })
    }), cancelRequestStatus === FAILED && /*#__PURE__*/_jsx(UIAlert, {
      use: "inline",
      className: "m-top-4",
      type: "danger",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cancel.failure.alert"
      })
    })]
  });

  return /*#__PURE__*/_jsx(CancelConfirmContainer, {
    children: /*#__PURE__*/_jsx(UICardWrapper, {
      className: "width-100 p-all-0 height-100",
      children: /*#__PURE__*/_jsx(UICardSection, {
        className: "p-all-0 height-100",
        children: /*#__PURE__*/_jsx("div", {
          className: "m-x-4 p-y-11 p-x-3 text-center",
          children: cancelRequestStatus === SUCCEEDED ? /*#__PURE__*/_jsx(SuccessState, {
            profile: profile,
            eventDetails: eventDetails
          }) : cancelForm
        })
      })
    })
  });
}